/** *********************************************
  Action types that are handled by auth reducer
********************************************** */
export default {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  RESTORE_PASSWORD_REQUEST: 'RESTORE_PASSWORD_REQUEST',
  RESTORE_PASSWORD_SUCCESS: 'RESTORE_PASSWORD_SUCCESS',
  RESTORE_PASSWORD_FAILURE: 'RESTORE_PASSWORD_FAILURE',
  RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',
  LOGOUT: 'LOG_OUT',
  CLEAR_AUTH_ERRORS: 'CLEAR_AUTH_ERRORS',
  ACCEPT_EULA_SUCCESS: 'ACCEPT_EULA_SUCCESS',
  FETCH_ACCOUNT_STATUS_SUCCESS: 'FETCH_ACCOUNT_STATUS_SUCCESS',
};



// WEBPACK FOOTER //
// src/actions/auth/actionTypes.js